import { Alert, Button, Form, Space, Typography } from 'antd'
import AuthorisedContainer from 'components/AuthorisedContainer'
import Vocabulary, { getVocabulary } from 'components/Vocabulary'
import { PermissionSetMap } from 'constants/RBACConstants'
import React, { useCallback, useEffect } from 'react'
import { ToolSeverityMappingAPI } from 'restAPI/ToolsIntegrationAPI'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { isUndefined } from 'lodash'
import { UPPERCASE_SEVERITIES } from 'views/Findings/Constants'

const severityMappingInitialValue = {
    LOW: "LOW",
    HIGH: "HIGH",
    MEDIUM: "MEDIUM",
    CRITICAL: "CRITICAL",
    INFO: "INFO",
}

const ToolSettingsSeverityMapping = ({toolName, handleToolSeverityChange}) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();
    
    const fetchData = useCallback(async ()  => {
        try{
            let resData = await ToolSeverityMappingAPI.getToolSeverityMapping().promise;
            resData = resData?.find(item => item.tool === toolName)
            if (isUndefined(resData)) {
                form.setFieldsValue(severityMappingInitialValue);
            } else {
                form.setFieldsValue({...resData.mapping})
            }
            handleToolSeverityChange(resData);
        } catch(err) {
            console.error(err)
        }
    }, [toolName, form, handleToolSeverityChange])

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData])

    const commonSeverityProps = {
        colSpan: 6,
        className: "m-b-0",
        type: FieldTypes.SELECT,
        options: Object.values(UPPERCASE_SEVERITIES).map(item => ({label: getVocabulary(item), value: item})),
    }

    const fields = [{
        name: "mapping",
        type: FieldTypes.GROUP,
        fields: Object.values(UPPERCASE_SEVERITIES).map(item => ({
            name: item,
            label: getVocabulary(item),
            ...commonSeverityProps
        }))
    }]


    // **************  Reset the Default value from database *********
    const onReset = () => {
        form.setFieldsValue(severityMappingInitialValue);
        handleToolSeverityChange({mapping: severityMappingInitialValue});
      };


    return (
        <Space direction="vertical" className="m-b-m">
            <Typography.Text>Tool to ArmorCode <Vocabulary name="severity" /> mapping</Typography.Text>
            <Alert 
                description={
                    <Form 
                        form={form}
                        style={{minWidth: 600}} 
                        layout="vertical"
                        onValuesChange={(_, values) => handleToolSeverityChange({mapping: values})}
                    >
                        {generateFormFields(fields)}

                        <Form.Item className="text-right p-x-sm" >
                            <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                                <Button type="primary" onClick={onReset}>Reset</Button>
                            </AuthorisedContainer>
                         </Form.Item>    
                    </Form>
                } 
            />
        </Space>
    )
}

export default ToolSettingsSeverityMapping
